const actionTypes = {
  InitializeLayout: 'INITIALIZE_LAYOUT',
};

export default actionTypes;
